import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";

const SubmittedBillingCell = ({ claim }) => {
  const { t } = useTranslation();

  return (
    <td>
      <a
        href={`${`https://api-dashboard.nordmann-inkasso.de`}/${claim.document.replace(/\\/g, '/')}`}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="d-inline-flex align-items-center gap-2 text-decoration-none"
        style={{
          fontSize: "14px",
          fontWeight: "500",
          color: "#374151", // neutral dark gray
          background: "#f9fafb", // light SaaS bg
          padding: "6px 12px",
          borderRadius: "8px",
          border: "1px solid #e5e7eb",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "#f3f4f6";
          e.currentTarget.style.boxShadow = "0 1px 3px rgba(0,0,0,0.08)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "#f9fafb";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        <FontAwesomeIcon icon={faFilePdf} className="text-danger" />
        <span>{t("DownloadBilling")}</span>
      </a>
    </td>
  );
};

export default SubmittedBillingCell;
